(function () {
  'use strict';

  // The theme's sticky-scroller re-measures the product info pane only on its own
  // accordions; nudge it when an add-on expander opens or closes too.
  document.addEventListener('toggle', function (e) {
    if (e.target.classList && e.target.classList.contains('kit-addons__details')) {
      window.dispatchEvent(new Event('resize'));
    }
  }, true);

  // Keep each expander's summary text in sync with the picked radio.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('kit-addons__radio')) return;
    var details = input.closest('details.kit-addons__details');
    if (!details) return;
    var out = details.querySelector('[data-summary]');
    if (!out) return;
    var text = input.closest('label').querySelector('.kit-addons__item-text');
    out.textContent = text ? text.textContent.replace(/\s+/g, ' ').trim() : 'None';
  });

  document.addEventListener('cart:item-added', function (evt) {
    var wrap = document.querySelector('.kit-addons');
    if (!wrap || wrap.dataset.busy === '1') return;

    var added = evt.detail && evt.detail.product;
    if (!added) return;
    var pid = String(added.product_id || '');
    if (pid !== wrap.dataset.productId) return;

    var picked = Array.prototype.slice.call(
      wrap.querySelectorAll('.kit-addons__select, .kit-addons__check:checked, .kit-addons__radio:checked')
    );
    var ids = picked
      .map(function (s) { return parseInt(s.value, 10); })
      .filter(function (v) { return v > 0; });
    if (!ids.length) return;

    var qtyInput = document.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!(qty > 0)) qty = 1;

    var items = ids.map(function (id) { return { id: id, quantity: qty }; });

    wrap.dataset.busy = '1';
    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: 'main-cart,cart-drawer,cart-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          console.error('Kit add-ons:', response.description || response.message);
          return;
        }
        var productForm = document.querySelector('product-form');
        if (productForm && typeof productForm.renderContents === 'function') {
          productForm.renderContents(response);
        }
      })
      .catch(function (e) { console.error('Kit add-ons:', e); })
      .finally(function () { wrap.removeAttribute('data-busy'); });
  });
})();
